define('helperContent-convertComponents',[],function() {
    'use strict';

    var convertComponents = function(comps){
        // combine 'key' and 'value' params to variables with 'key's value as name and 'value's value as value :)
        if(comps) {
            if (comps.length > 0) {
                comps.forEach(function (comp) {
                    if (comp.content.length > 0) {
                        var content = {index: []};
                        comp.content.forEach(function (item) {
                            content[item.key] = item.value;
                            content.index.push(item.key);
                            if (content[item.key] instanceof Array && content[item.key].length) {
                                if (content[item.key][0].content != undefined) {
                                    content[item.key] = convertComponents(item.value);
                                }
                            }
                        });
                        comp.content = content;
                    }
                });
            }
        }else{
            // empty array
            comps = [];
        }
        return comps;
    }

    return convertComponents;
});

